import type { ReactElement } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { logger } from '../utils/logger'
import { ProtectedRoute } from '../components'
import { DashboardLayout } from '../shell'
import {
  CaseDetailPage,
  ClientsPage,
  DashboardPage,
  LandingPage,
  LoginPage,
  UnauthorizedPage,
} from '../pages'
import { adminProtectedRoutes } from './AppRoutes.parts'

const handleLearnMore = (): void => {
  logger.debug('App', 'Learn more clicked')
}
const handleAbout = (): void => {
  logger.debug('App', 'About clicked')
}
const handlePricing = (): void => {
  logger.debug('App', 'Pricing clicked')
}

function PublicRoutes(): ReactElement {
  return (
    <>
      <Route
        path="/"
        element={
          <LandingPage
            onLearnMore={handleLearnMore}
            onAbout={handleAbout}
            onPricing={handlePricing}
          />
        }
      />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />
    </>
  )
}

function ProtectedRoutes(): ReactElement {
  return (
    <Route
      element={
        <ProtectedRoute>
          <DashboardLayout />
        </ProtectedRoute>
      }
    >
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/cases/:caseId" element={<CaseDetailPage />} />
      <Route path="/clients" element={<ClientsPage />} />
      {adminProtectedRoutes()}
    </Route>
  )
}

export function AppRoutes(): ReactElement {
  return (
    <Routes>
      {PublicRoutes()}
      {ProtectedRoutes()}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
